import clsx from "classnames";
import { Container } from "react-bootstrap";
import { Form } from "@/ui/Form";
import { useLocale } from "@/hooks/useLocale";
import classes from "./styles.module.scss";

export const SimplePageFormSection = ({ className, page }) => {
  const locale = useLocale();

  if (!page?.form || page?.form.length === 0) {
    return null;
  }

  const [form] = page?.form;

  return (
    <div className={clsx(className, classes.section)}>
      <Container className="mw-lg">
        <div className="bg-secondary text-white p-5">
          {form[`title_${locale}`] && <h3>{form[`title_${locale}`]}</h3>}
          <Form
            className={classes.section__form}
            formId={form["form_id"]}
            onSubmitDone={() => {
              if (typeof window !== "undefined") {
                window.location.href = form["redirect_url"];
              }
            }}
          />
        </div>
      </Container>
    </div>
  );
};

SimplePageFormSection.defaultProps = {
  className: "py-4 py-md-5",
};
